import { render, staticRenderFns } from "./prosync_repots.vue?vue&type=template&id=c5af39aa&"
import script from "./prosync_repots.vue?vue&type=script&lang=js&"
export * from "./prosync_repots.vue?vue&type=script&lang=js&"
import style0 from "./prosync_repots.vue?vue&type=style&index=0&id=c5af39aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports